enum MenuModifierPriceDisplayStyle {
  ShowPriceOnAllMods = 'show-price-on-all-mods',
  ShowPriceInHeader = 'show-price-in-header',
}

export { MenuModifierPriceDisplayStyle };
